<div class="mt-3 mr-2 menu-container">
  <mat-accordion displayMode="flat" class="child-headers-align" multi>
    <div class="action-bar">
      <mat-form-field class="filter-form-field">
        <span matPrefix>
          <mat-icon class="prefix-icon">filter_list</mat-icon>
        </span>
        <input
          #input
          matInput
          [placeholder]="'pages.home.filter' | translate"
          [(ngModel)]="searchValue"
          (ngModelChange)="checkFilterEmpty()"
        />
        @if (searchValue) {
        <button
          mat-button
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="searchValue = ''"
        >
          <mat-icon>close</mat-icon>
        </button>
        } @if (!searchValue) {
        <span matSuffix>
          <mat-icon>search</mat-icon>
        </span>
        }
      </mat-form-field>

      @if (expandAll) {
      <button mat-icon-button (click)="expandAll = false">
        <mat-icon>unfold_less</mat-icon>
      </button>
      } @if (!expandAll) {
      <button mat-icon-button (click)="expandAll = true">
        <mat-icon>unfold_more</mat-icon>
      </button>
      }
    </div>

    @for (category of categories; track category) {
    <div>
      @if (filter(category)) {
      <mat-expansion-panel
        style="padding: 0px; border: none"
        class="rounded-0"
        [expanded]="expandAll"
      >
        <mat-expansion-panel-header>
          <mat-panel-title class="menu-item">{{
            groupedCategories[category][0].category_description | translate
          }}</mat-panel-title>
        </mat-expansion-panel-header>
        @for (widget of groupedCategories[category]; track widget) {
        <div>
          <app-menu-item
            [widget]="widget"
            [isDisabled]="isDisabled"
            (onAddWidget)="onAddWidget($event)"
            (onRemoveWidget)="onRemoveWidget($event)"
          >
          </app-menu-item>
        </div>
        }
      </mat-expansion-panel>
      }
    </div>
    }
  </mat-accordion>
</div>
